import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
// import SearchForm from '../../../components/global/searchForm';
import SearchFormV2 from '../../../components/global/searchFormV2';

import { Title } from './title';
import { KhersonAction } from './khersonAction';
import NotificationsBanner from './NotificationsBanner';
import DeprecationModal from './DeprecationModal';
import ScreeningBanner from '../screeningBanner';

const IntroSection = ({ user, searchFocused }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Container>
      <Row>
        <Col lg={{ span: 12 }} xl={{ span: 12 }}>
          <NotificationsBanner user={user} />
          <div className={`intro-section${searchFocused ? ' search-focused' : ''}`}>
            <KhersonAction user={user} />
          </div>

          {false && isModalVisible && (
            <div className="d-md-none" style={{ marginTop: '15px' }}>
              <ScreeningBanner mini />
            </div>
          )}

          <div style={{ position: 'relative' }}>
            <DeprecationModal onVisibilityChange={setIsModalVisible} />
            <Title />
            <SearchFormV2 />
            <div className="main-title-wrapper">
              <div className="sub-title">У результатах пошуку відображаються виключно медичні працівники та заклади охорони здоров’я, які використовують МІС «Каштан».</div>
            </div>
          </div>

          <KhersonAction user={user} searchFocused={searchFocused} />
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default IntroSection;
